<script setup lang="ts">
export interface BaseHeaderDropdownLocaleProps {
  defaultLocale?: ILocale; // TODO: do we actually need it?
  availableLocales: ILocale[];
  closeBtn?: boolean;
}

const props = withDefaults(defineProps<BaseHeaderDropdownLocaleProps>(), {
  closeBtn: false,
});
const { t, locale: currentLocale, setLocale } = useI18n();
const headerDropdownRef = ref(null);
const isLocaleMenuExpanded = ref(false);

const setLocaleDropdown = (value: boolean) => (isLocaleMenuExpanded.value = value);
const onLocaleDropdownClick = () => setLocaleDropdown(!isLocaleMenuExpanded.value);
const onSelectLocale = (selectedLocale: string) => {
  setLocale(selectedLocale);
  onLocaleDropdownClick();
};

onClickOutside(headerDropdownRef, () => setLocaleDropdown(false));
</script>

<template>
  <div
    ref="headerDropdownRef"
    class="headerDropdown"
    :class="{ headerDropdown_open: isLocaleMenuExpanded }"
  >
    <BaseButton
      type="icon"
      name="header-locale-dropdown"
      title="Switch locale"
      :aria-expanded="isLocaleMenuExpanded"
      @click="onLocaleDropdownClick"
    >
      <div class="flex items-center justify-center gap-2">
        <IconHeaderLocale fill="var(--base-icon-color)" />
        <span class="text-[var(--base-secondary-text-color)] font-medium uppercase truncate">
          {{ currentLocale }}
        </span>
      </div>
    </BaseButton>

    <div
      class="headerDropdown__menu"
      :class="{ headerDropdown__menu_open: isLocaleMenuExpanded }"
    >
      <div v-if="props.closeBtn" class="flex justify-between text-secondary p-6">
        <div>{{ t("locales.title") }}</div>
        <BaseButton
          tag="button"
          type="icon"
          name="baseHeaderDropdownLocaleCloseBtn"
          @click="onLocaleDropdownClick"
        >
          <IconSearchClose class="relative z-10" />
        </BaseButton>
      </div>
      <ul>
        <li
          v-for="locale in props.availableLocales"
          :key="locale"
          class="text-secondary m-6"
        >
          <BaseButton
            type="icon"
            name="header-locale-dropdown-option"
            class="text-link !flex justify-between"
            full-width
            @click="onSelectLocale(locale)"
          >
            <span class="text-main">{{ t(`locales.${locale}`) }}</span>
            <IconCheck v-if="locale === currentLocale" />
          </BaseButton>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.headerDropdown {
  @apply relative h-full flex items-center;

  .headerDropdown__menu {
    @apply hidden overflow-hidden absolute z-30 right-0 w-[300px];
    top: calc(100% + 2.5rem);
    background-color: var(--base-card-bgColor);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: var(--base-box-shadow);
    height: auto;

    &.headerDropdown__menu_open {
      @apply block;
    }
  }
}
</style>
